import { useEffect, useRef } from "react";
import { createVisiblePoller } from "@/lib/visible-polling.mjs";

export function useVisiblePolling(
  poll: () => void | Promise<void>,
  {
    enabled = true,
    intervalMs,
    refreshOnVisible = true,
  }: {
    enabled?: boolean;
    intervalMs: number;
    refreshOnVisible?: boolean;
  },
) {
  const pollRef = useRef(poll);
  useEffect(() => {
    pollRef.current = poll;
  }, [poll]);

  useEffect(() => {
    if (!enabled) return;
    const poller = createVisiblePoller({
      poll: () => pollRef.current(),
      intervalMs,
      isVisible: () => document.visibilityState === "visible",
      setTimer: (callback, delay) => window.setTimeout(callback, delay),
      clearTimer: (timer) => window.clearTimeout(timer as number),
      subscribeVisibility: (callback) => {
        document.addEventListener("visibilitychange", callback);
        return () => document.removeEventListener("visibilitychange", callback);
      },
      refreshOnVisible,
    });
    poller.start();
    return () => poller.stop();
  }, [enabled, intervalMs, refreshOnVisible]);
}
